// @flow

class IngestUtil {
	/**
	 * [initAnalytics Init Ingest]
	 * @return {[none]}
	 */
	initAnalytics(ingestObject: Object) {
		ingestObject.initializeDefaultData();
	}

	/**
	 * [replaceSpaces replace spaces with dashes]
	 * @param  {[string]} text
	 * @return {[string]}  modified text
	 */
	replaceSpaces(text: string) {
		let newVal = text.trim();

		newVal = newVal.replace(/\s+/g, '-');

		// if the first char is now a '-', get rid of it
		if (newVal.length && newVal.charAt(0) === '-') {
			newVal = newVal.substr(1);
		}

		return newVal;
	}

	/**
	 * [sendToIngest Post to ingest]
	 * @return {[none]}
	 */
	sendToIngest(ingestObject: Object, logMetricsCollection: number) {
		if (typeof ingestObject.metricsCollection !== 'undefined' && ingestObject.metricsCollection.length) {
			if (logMetricsCollection) {
				const arrayLength = ingestObject.metricsCollection.length;
				console.log('metricsCollection.length = ', ingestObject.metricsCollection.length);
				for (let i = 0; i < arrayLength; i++) {
					console.log('sendToIngest metricsCollection = ', ingestObject.metricsCollection[i].events[0].data);
				}
			}
			// send the events to the CCHome intents server also
			if (window.eventsService) {
				window.eventsService.reportEvents(ingestObject.metricsCollection);
			}
			return ingestObject.sendToIngest().catch((err) => {
				console.error(err);
			});
		}
		return null;
	}

	setIngestDataValue(ingestObject: Object, dataObject: Object) {
		
		Object.keys(dataObject).forEach((key) => {
			const value = dataObject[key];
			if (value !== null && typeof value !== 'undefined') {
				switch (key) {
					case 'setEventWorkflow':
						ingestObject.setDataValue('event', 'workflow', value);
						break;
					case 'setEventCategory':
						ingestObject.setDataValue('event', 'category', value);
						break;
					case 'setEventSubcategory':
						ingestObject.setDataValue('event', 'subcategory', value);
						break;
					case 'setEventValue':
						ingestObject.setDataValue('event', 'value', value);
						break;
					case 'setEventType':
						ingestObject.setDataValue('event', 'type', value);
						break;
					case 'setEventSubtype':
						ingestObject.setDataValue('event', 'subtype', value);
						break;
					case 'setEventCount':
						ingestObject.setDataValue('event', 'count', value);
						break;
					case 'setEventLanguage':
						ingestObject.setDataValue('event', 'language', value);
						break;
					case 'setEventErrorCode':
						ingestObject.setDataValue('event', 'error_code', value);
						break;
					case 'setEventErrorDesc':
						ingestObject.setDataValue('event', 'error_desc', value);
						break;
					case 'setEventOffline':
						ingestObject.setDataValue('event', 'offline', value);
						break;
					case 'setEventContextGUID':
						ingestObject.setDataValue('event', 'context_guid', value);
						break;
					case 'setEventGUID':
						ingestObject.setDataValue('event', 'guid', value);
						break;
					case 'setEventContextSequence':
						ingestObject.setDataValue('event', 'context_sequence', value);
						break;
					case 'setContentID':
						ingestObject.setDataValue('content', 'id', value);
						break;
					case 'setContentName': {
						// Splunk seems to be having problems with spaces
						const newVal = this.replaceSpaces(value);
						ingestObject.setDataValue('content', 'name', newVal);
					}
						break;
					case 'setContentType':
						ingestObject.setDataValue('content', 'type', value);
						break;
					case 'setContentCategory':
						ingestObject.setDataValue('content', 'category', value);
						break;
					case 'setContentAction':
						ingestObject.setDataValue('content', 'action', value);
						break;
					case 'setContentAuthor':
						ingestObject.setDataValue('content', 'author', value);
						break;
					case 'setContentVersion':
						ingestObject.setDataValue('content', 'version', value);
						break;
					case 'setContentSize':
						ingestObject.setDataValue('content', 'size', value);
						break;
					case 'setContentStatus':
						ingestObject.setDataValue('content', 'status', value);
						break;
					case 'setUIFilter':
						ingestObject.setDataValue('ui', 'filter', value);
						break;
					case 'setUIViewType':
						ingestObject.setDataValue('ui', 'view_type', value);
						break;
					case 'setUISequence':
						ingestObject.setDataValue('ui', 'sequence', value);
						break;
					case 'setUISearchKeyword':
						ingestObject.setDataValue('ui', 'search_keyword', value);
						break;
					case 'setEnvComName':
						ingestObject.setDataValue('env', 'com.name', value);
						break;
					case 'setEnvironmentServiceName':
						ingestObject.setDataValue('env', 'svc.name', value);
						break;
					case 'setEnvironmentServiceVersion':
						ingestObject.setDataValue('env', 'svc.version', value);
						break;
					case 'setComponentVersion':
						ingestObject.setDataValue('env', 'com.version', value);
						break;
					case 'setFrameworkName':
						ingestObject.setDataValue('env', 'fw.name', value);
						break;
					case 'setErrorCode':
						ingestObject.setDataValue('event', 'error_code', value);
						break;
					case 'setErrorType':
						ingestObject.setDataValue('event', 'error_type', value);
						break;
					case 'setErrorDesc':
						ingestObject.setDataValue('event', 'error_desc', value);
						break;
					case 'setSearchKeyword':
						ingestObject.setDataValue('event', 'search_keyword', value);
						break;
					case 'setContentExtension': // Sends the latest version of the app being downloaded
						ingestObject.setDataValue('content', 'extension', value);
						break;
					case 'setExpCampaignID':
						ingestObject.setDataValue('exp', 'campaign_id', value);
						break;
					case 'setExpVariationID':
						ingestObject.setDataValue('exp', 'variation_id', value);
						break;
					case 'setExpExperienceID':
						ingestObject.setDataValue('exp', 'experience_id', value);
						break;
					case 'setExpContainerID':
						ingestObject.setDataValue('exp', 'container_id', value);
						break;
					case 'setExpSurfaceID':
						ingestObject.setDataValue('exp', 'surface_id', value);
						break;
					case 'setExpTreatmentID':
						ingestObject.setDataValue('exp', 'treatment_id', value);
						break;
					case 'setExpActionBlockId':
						ingestObject.setDataValue('exp', 'action_block_id', value);
						break;
					case 'setExpResponseGuid':
						ingestObject.setDataValue('exp', 'response_guid', value);
						break;
					case 'setEventIDP':
						ingestObject.setDataValue('event', 'idp', value);
						break;
					case 'setConsumerClientID':
						ingestObject.setDataValue('consumer', 'client_id', value);
						break;
					case 'setConsumerName':
						ingestObject.setDataValue('consumer', 'name', value);
						break;
					case 'setConsumerVersion':
						ingestObject.setDataValue('consumer', 'version', value);
						break;
					case 'setOSVersion':
						ingestObject.setDataValue('source', 'os_version', value);
						break;
					case 'setIngestContextGuid':
						ingestObject.setDataValue('context', 'guid', value);
						break;
					case 'setIngestContextParams':
						ingestObject.setDataValue('context', 'params', value);
						break;
					case 'setIngestContextInit':
						ingestObject.setDataValue('context', 'init', value);
						break;
					default:
						console.log('Invalid key for Apps Service');
						break;
				}
			}
		});
		
		ingestObject.setDataValue('event', 'pagename', document.title);

	}
}

export default new IngestUtil();
